import {UserProperties} from '../utils/userProperties'

import {useBooleanUserProperty} from './useUserProperty'

export const useIsAutodetectTimeZone = () =>
  useBooleanUserProperty(UserProperties.AUTODETECT_TIMEZONE)
